import type { Context, ReactNode } from 'react';
import { useMemo, useState } from 'react';

import { type IContext } from '../../types/icontext';

type ContextProviderProps = {
  children: ReactNode;
};

export const createContextProvider =
  <T,>(Context: Context<IContext<T>>) =>
  ({ children }: ContextProviderProps) => {
    const [contextItems, setContextItems] = useState<T>();

    const value = useMemo(() => ({ contextItems, setContextItems }), [contextItems]);

    return <Context.Provider value={value}>{children}</Context.Provider>;
  };
